/**
 * Detección centralizada de plataforma de ejecución.
 *
 * En esta etapa sólo Android APK activa lógica nativa real (Push). iOS está
 * detectado para evolución futura — no se activa nada todavía. Cualquier otro
 * entorno (Chrome móvil, escritorio, Safari móvil sin Capacitor) cuenta como
 * web y debe seguir funcionando sin tocar APIs nativas.
 */

const safeWindow = () => (typeof window === "undefined" ? null : window);

export const getCapacitor = () => {
  const w = safeWindow();
  return w && w.Capacitor ? w.Capacitor : null;
};

export const isNative = () => {
  const cap = getCapacitor();
  if (!cap) return false;
  if (typeof cap.isNativePlatform === "function") return cap.isNativePlatform();
  return !!cap.isNative;
};

/** "android" | "ios" | "web" */
export const getPlatform = () => {
  const cap = getCapacitor();
  if (cap && typeof cap.getPlatform === "function") {
    const p = cap.getPlatform();
    if (p === "android" || p === "ios") return p;
  }
  return "web";
};

export const isAndroidNative = () => isNative() && getPlatform() === "android";
export const isIosNative = () => isNative() && getPlatform() === "ios";
export const isWeb = () => !isNative();
